import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useSyncInstallments() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (cessionId: number) => capitalMarketsService.syncInstallments(cessionId),
    onError: (error: any) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      const errorMessages = {
        400: 'A ação não é permitida para o status atual da cessão.',
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
        404: 'Cessão não encontrada.',
        422: 'Não é possível baixar as parcelas no estado atual.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || message
        || 'Erro inesperado ao baixar parcelas.';

      toast.error(errorMessage);
    },
    onSuccess: () => {
      toast.success('Solicitação de sincronização de parcelas enviada com sucesso.');
      queryClient.invalidateQueries({ queryKey: ['cession', 'detail'] });
    },
    retry: 3,
    retryDelay: 1000,
  });
}
